/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import PropTypes from 'prop-types';
import _, { update } from 'lodash';
import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { TWIAStandardizeButton, TWIAStandardizationStatus } from 'twia-capability-address-component';
import StandardAddressValidationUtil from '../../../../../modules-react/twia-capability-address-component/util/StandardAddressValidationUtil';
import metadata from './AdditionalInterestDetails.metadata.json5';
import messages from './AdditionalInterestDetails.messages.js';
import styles from '../AdditionalInterestComponent.module.scss';
import addressControl from '../../../../../modules-react/twia-capability-address-component/util/addressControl.js';
import { AddressStandardizationService } from 'twia-capability-addressstandardization';
import { LocaleService_TWIA } from 'twia-capability-locale';

function AdditionalInterestDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { item, saveData, cancelData, isInvalid, showErrors, onValidate, companyType } = props;
    const { authHeader } = useAuthentication();
    const {
        isComponentValid,
        onValidate: setComponentValidation,
    } = useValidation('AdditionalInterestDetails');

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);
    const [additionalInfoVM, setAdditionalInfoVM] = useState(item);
    const isPhoneNumberValid = (phone) => /^[2-9]\(?([0-9]{2})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/.test(phone);
    const [zipcodeValidationMessage, setZIPCodeValidationMessage] = useState([]);
    const [emailValidationMessage, setEmailValidationMessage] = useState([]);
    const [phoneValidationMessage, setPhoneValidationMessage] = useState([]);
    const [cityLabel, setCityLabel] = useState([]);
    const [zipCodeLabel, setZIPCodeLabel] = useState([]);
    const [stateLabel, setStateLabel] = useState([]);
    const isInterestTypeMortgage = _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].type.value.code')
    const { refreshData } = useDataRefresh();
    const countryCode = _.get(additionalInfoVM, 'primaryAddress.country.value.code')
    const interestTypeValue = _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].type.value.code')
    const personContact = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.ContactType').getCode('person');
    const companyContact = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.ContactType').getCode('company');
    const isLoanNumberVisible = _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].contractNumber.aspects.visible');
    const isLoanNumberRequired = _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].contractNumber.aspects.required');
    const [placeholderMsg, setPlaceHolderMsg] = useState('');
    const [showAddressValidationStatus, setStatus] = useState(false);
    const [isButtonDisabled, updateDisablity] = useState(false);
    const [ pcConstants, setPCConstants ] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [regex, setRegex] = useState('');
    const [addInterestButton, setaddInterestButton] = useState(false);
    const [ isAddressEdited, setIsAddressEdited ] = useState(false); //DE16671
    const [noMatchFound, setNoMatchFound] = useState(false);
    const xPortal = 'PE';
    const mailingAddressTypeCode = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.AddressType').getCode('mailingExt');

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'AdditionalInterestDetails');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        isInvalid(isComponentValid, 'AdditionalInterestDetails');
    }, [isInvalid, isComponentValid])

    useEffect(() => {
        const val = additionalInfoVM?.primaryAddress.value || additionalInfoVM?.primaryAddress; //DE17215. DE17265
        setNoMatchFound(val.addressStandResult?.noAddressMatchFound);
    },[additionalInfoVM?.primaryAddress]);

    useEffect(() => {
        getLabel(countryCode);
        getAddressConfig(countryCode);
        getPCConstants();
       setStatus(addressControl.showStatus(additionalInfoVM.primaryAddress.value, xPortal));
       if(isInterestTypeMortgage === 'MORTGAGEE' || interestTypeValue === 'PREMFINANCE_TWIA' || countryCode !== 'US'){
        _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', false);
        setAdditionalInfoVM(additionalInfoVM);
       } else {
        _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', true);
        setAdditionalInfoVM(additionalInfoVM);
    }
    }, [countryCode]);

    const getPCConstants = useCallback(async () => {
        const constants = await AddressStandardizationService.getPCPortalConstants(authHeader);
        if (constants.addressStandardizationDisabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }
        setPCConstants(constants);
    }, []);

    const setDisablity = useCallback((value) => {
        if (isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal));
            setaddInterestButton(true);
        }
        refreshData();
    }, [updateDisablity, refreshData]);

    const getLabel = (value) => {
        setZIPCodeLabel([]);
        setCityLabel([]);
        setStateLabel([]);

        switch (value) {
            case 'US':
                setZIPCodeLabel('ZIP Code');
                setCityLabel('City');
                setStateLabel('State');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
            case 'CA':
                setZIPCodeLabel('Postal Code');
                setCityLabel('City');
                setStateLabel('Province');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
            case 'GB':
                setCityLabel('Town/City');
                setZIPCodeLabel('Postcode');
                setStateLabel('State');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
            case 'JP':
                setCityLabel('City (phonetic)');
                setZIPCodeLabel('Postcode');
                setStateLabel('Prefecture');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
            default:
                setCityLabel('City');
                setZIPCodeLabel('Postcode');
                setStateLabel('State');
                setPlaceHolderMsg(messages.pleaseChoose);
                break;
        }
    }

    const getAdditionalInterestTypeValues = useCallback(() => {
        const availableInterestTypeValues = additionalInfoVM.policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].type.aspects.availableValues

        if (availableInterestTypeValues.length > 0) {
            const availableInterestType = availableInterestTypeValues.map((code) => {
                return {
                    code: code.code,
                    name: translator({ id: code.name })
                }
            })

            return availableInterestType
        }
    }, [additionalInfoVM, translator]);

    const getAvailableMortgageValues = useMemo(() => {
        const availableMortgageValues = viewModelService.productMetadata.get('pc').types.getTypelist('MortgagePositionType_ext').codes.map((code) => {
            return {
                code: code.code,
                name: translator({ id: code.name })
            }
        })

        return availableMortgageValues
    }, [viewModelService, translator]);

    const getAvailablePremiumFinaceCompany = useMemo(() => {
        const availablePremiumFinanceValues = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.PremiumFinCompany_TWIA').codes.map((code) => {
            return {
                code: code.code,
                name: translator({ id: code.name })
            }
        })

        return availablePremiumFinanceValues
    }, [viewModelService, translator]);

    const contactTypeChange = useCallback((value, path) => {
        _.set(additionalInfoVM, path, value);

        if (value === 'Person') {
            _.set(additionalInfoVM, 'contactType_TWIA.value', personContact)
        } else {
            _.set(additionalInfoVM, 'contactType_TWIA.value', companyContact)
        }

        getAdditionalInterestTypeValues()
        setAdditionalInfoVM(additionalInfoVM);
        refreshData();
    }, [additionalInfoVM, companyContact, getAdditionalInterestTypeValues, personContact, refreshData]);

    const countryChange = useCallback((value, path) => {
        _.set(additionalInfoVM, 'primaryAddress.state', undefined);
        if(value !== 'US'){
            _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', false);
            setAdditionalInfoVM(additionalInfoVM);
            setaddInterestButton(true);
        } else {
            _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', true);
            setAdditionalInfoVM(additionalInfoVM);
        }
        getLabel(value);
        getAddressConfig(value);
        _.set(additionalInfoVM, path, value);
        setStatus(addressControl.showStatus(additionalInfoVM.primaryAddress.value, xPortal));
        setAdditionalInfoVM(additionalInfoVM);
        refreshData();
    }, [additionalInfoVM, refreshData]);

    const getAddressConfig = useCallback(
        async (value) => {
            await LocaleService_TWIA.getLocal_TWIA(value, authHeader).then(
                (locale) => {
                    setRegex(locale.postalCodeRegex);
                }
            )
        },
        []);

    const validateRegex = (idRegex, target) => {
        // eslint-disable-next-line security/detect-non-literal-regexp
        if(idRegex === undefined){
            return true
        }
        const regex = new RegExp(`^${idRegex}$`); //DE16011
    
        return regex.test(target);
    };
    
    const validateZIPCode = useCallback(() => {
        const code = _.get(additionalInfoVM.primaryAddress.value, 'postalCode');
        const isCodevalid = code === "" ? true : validateRegex(regex, code); //DE16011
        setZIPCodeValidationMessage([]);
        if (!isCodevalid ){   
            setZIPCodeValidationMessage([translator(messages.ZIPCodeValidationMessage)]); //DE16364
        }
        return '';
    }, [additionalInfoVM, regex]);

    const validateEmail = useCallback(
        (value, path) => {
            _.set(additionalInfoVM, path, value);
            setEmailValidationMessage([]);

            if (!value) {

                setEmailValidationMessage([]);
            } else if (!_.get(additionalInfoVM, `${path}.aspects.valid`)) {

                setEmailValidationMessage([translator(messages.EmailValidationMessage)])
            }

            setAdditionalInfoVM(additionalInfoVM);
        },
        [additionalInfoVM, translator]);

    const validatePhoneNumber = useCallback(
        (value, path) => {

            if (value.match(/[a-z A-Z]/g)) {
                return false;
            }

            if (value.length === 3 || value.length === 7) {
                value += "-"
            }

            setPhoneValidationMessage([]);

            if (!value) {

                setPhoneValidationMessage([]);
            } else if (!isPhoneNumberValid(value) || value.match(/[0-9]/g).length < 10) {

                setPhoneValidationMessage([translator(messages.PhoneValidationMessage)])
            }

            _.set(additionalInfoVM, path, value);
            setAdditionalInfoVM(additionalInfoVM);
        },
        [additionalInfoVM, translator]);


        const handleStandardizationResponse =useCallback((value)=> {
            const val = additionalInfoVM.primaryAddress?.value || additionalInfoVM.primaryAddresss; //DE17351
            if(xPortal === 'CC'){
                setNoMatchFound(val.addressStandResult?.noAddressMatchFound);
            } else {
                setNoMatchFound(value.noAddressMatchFound);
            }
        });

    const updateSubmissionVM = useCallback((value) => {
        _.set(additionalInfoVM, 'primaryAddress', value);
        _.set(additionalInfoVM, 'primaryAddress.addressType.value', mailingAddressTypeCode); // DE17373
        setDisablity(value);
        setIsAddressEdited(false); // DE16671
        setAdditionalInfoVM(additionalInfoVM);
    }, [additionalInfoVM, setAdditionalInfoVM]);


    const saveAdditionalInterest = () => {
        if(!isComponentValid) {
            errorHandling();
            isInvalid(isComponentValid, 'AdditionalInsuredDetails');
        } else {
            saveData(additionalInfoVM);
            setIsAddressEdited(false);
        }
    }

    const cancelAdditionalInterest = () => {
        isInvalid(true, 'AdditionalInterestDetails');
        cancelData();
    }

    const writeValue = useCallback(
        (value, path) => {
            if (path === 'primaryAddress.addressLine1'
                || path === 'primaryAddress.addressLine2'
                || path === 'primaryAddress.city'
                || path === 'primaryAddress.state'
                || path === 'primaryAddress.county'
                || path === 'primaryAddress.postalCode'
                || path === 'primaryAddress.country')
            {
                StandardAddressValidationUtil.setNotValidated(additionalInfoVM.primaryAddress.value);
                setStatus(addressControl.showStatus(additionalInfoVM.primaryAddress.value, xPortal));
                setAdditionalInfoVM(additionalInfoVM);
                // DE16765
                if (countryCode === 'US') {
                    if (isInterestTypeMortgage === 'MORTGAGEE' || interestTypeValue === 'PREMFINANCE_TWIA') {
                        _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', false);
                        setIsAddressEdited(false);
                    } else {
                        setIsAddressEdited(true);
                    }
                } else {
                    setIsAddressEdited(false);
                }
            }
            if (path === 'primaryAddress.country') {
                getLabel(value)
            }
            if(path === 'primaryAddress.country' && value !== 'US'){
                _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', false);
                setAdditionalInfoVM(additionalInfoVM);
            }
            // DE16553
            if (path === 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].type') {
            if((value === 'MORTGAGEE') || (value === 'PREMFINANCE_TWIA')){
                _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', false);
                setAdditionalInfoVM(additionalInfoVM);
               } else {
                _.set(additionalInfoVM, 'primaryAddress.mustStandardize_Ext.value', true);
                setAdditionalInfoVM(additionalInfoVM);
            }
        }
            if (path === 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].contractNumber' && value) {
                if (value.match(/\s/g)) {
                    return false;
                }
            }
            _.set(additionalInfoVM, path, value);
            setAdditionalInfoVM(additionalInfoVM);
            refreshData();
        },
        [additionalInfoVM, countryCode, interestTypeValue, isInterestTypeMortgage, refreshData]
    );

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        name: {
            visible: additionalInfoVM?.subtype.value === 'Company'
        },
        firstName: {
            visible: additionalInfoVM?.subtype.value === 'Person'
        },
        lastName: {
            visible: additionalInfoVM?.subtype.value === 'Person'
        },
        interestType: {
            path: 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].type',
            availableValues: additionalInfoVM ? getAdditionalInterestTypeValues() : []
        },
        loanNumber: {
            visible: isLoanNumberVisible,
            path: 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].contractNumber',
            required: isLoanNumberRequired,
            showRequired: isLoanNumberRequired
        },
        mortgagePosition: {
            path: 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].mortgagePosition_TWIA',
            availableValues: getAvailableMortgageValues,
            visible: isInterestTypeMortgage === 'MORTGAGEE',
            required: isInterestTypeMortgage === 'MORTGAGEE',
            showRequired: isInterestTypeMortgage === 'MORTGAGEE'
        },
        premiumFinaceCompany: {
            visible: additionalInfoVM?.subtype.value === 'Company' && _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].premiumFinanceCompanyType_TWIA.aspects.visible'),
            required: _.get(additionalInfoVM, 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].premiumFinanceCompanyType_TWIA.aspects.required'),
            availableValues: getAvailablePremiumFinaceCompany,
            defaultValue: getAvailablePremiumFinaceCompany[0],
            path: 'policyContactRoles.children[0].policyAdditionalInterest.additionalInterestDetails.children[0].premiumFinanceCompanyType_TWIA',
        },
        cityKanji: {
            visible: countryCode === 'JP'
        },
        city: {
            label: cityLabel,
            visible: countryCode !== 'JP',
        },
        phonetic: {
            label: cityLabel,
            visible: countryCode === 'JP',
        },
        state: {
            label: stateLabel,
            visible: countryCode === 'US' || countryCode === 'CA' || countryCode === 'AU' || countryCode === 'DE',
            required: countryCode === 'US' || countryCode === 'CA' || countryCode === 'AU' || countryCode === 'JP' || countryCode === 'DE',
            showRequired: countryCode === 'US' || countryCode === 'CA' || countryCode === 'AU' || countryCode === 'JP' || countryCode === 'DE',
            placeholder: placeholderMsg
        },
        // DE15914
        prefecture: {
            label: stateLabel,
            visible: countryCode === 'JP',
            required: countryCode === 'JP',
            showRequired:countryCode === 'JP',
            placeholder: placeholderMsg
        },
        zipCode: {
            label: zipCodeLabel,
            onBlur: validateZIPCode,
            validationMessages: zipcodeValidationMessage,
            visible : countryCode !== 'FR' && countryCode !== 'JP'
        },
        postCodeFr : {
            label: zipCodeLabel,
            onBlur: validateZIPCode,
            validationMessages: zipcodeValidationMessage,
            visible : countryCode === 'FR' && countryCode !== 'JP'
        },
        postCodeJp : {
            label: zipCodeLabel,
            onBlur: validateZIPCode,
            validationMessages: zipcodeValidationMessage,
            visible : countryCode === 'JP' && countryCode !== 'FR'
        },
        cedex: {
            visible: countryCode === 'FR'
        },
        cedexBureau: {
            visible: countryCode === 'FR' && _.get(additionalInfoVM, 'primaryAddress.cedex_Ext.value') === true
        },
        emailAddress: {
            validationMessages: emailValidationMessage
        },
        phoneNumber: {
            validationMessages: phoneValidationMessage,
        },
        statusComponent: {
            visible: (interestTypeValue === 'LOSSP' || interestTypeValue === 'CONSALE') && showAddressValidationStatus,
            primaryAddressVM: additionalInfoVM.primaryAddress.value, status:showAddressValidationStatus,
            isStandardizationDisabled,
            noMatchFound
        },
        buttonComponent: {
            visible: interestTypeValue === 'LOSSP' || interestTypeValue === 'CONSALE',
            primaryAddressVM: additionalInfoVM.primaryAddress.value, 
            updatePrimaryAddressVM: updateSubmissionVM ,
            authHeader, 
            companyType,
            isStandardizationDisabled,
            standardizationResponse: handleStandardizationResponse,
            xPortal,
            zipCodevalidationMsg: zipcodeValidationMessage
        },
        saveButton: {
            disabled: (isInterestTypeMortgage === 'MORTGAGEE' || interestTypeValue === 'PREMFINANCE_TWIA')
            ? isComponentValid === false 
            : isComponentValid === false || !addInterestButton || isAddressEdited || isButtonDisabled// DE16671 
        } 
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            OnValidateEmail: validateEmail,
            OnValidatePhoneNumber: validatePhoneNumber,
            onSave: saveAdditionalInterest,
            onCancel: cancelAdditionalInterest,
            onContactTypeChange: contactTypeChange,
            onCountryChange: countryChange
        },
        resolveComponentMap: {
            standardizeButtonComponent: TWIAStandardizeButton,
            standardizeStatusComponent: TWIAStandardizationStatus
        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={additionalInfoVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}

AdditionalInterestDetails.propTypes = {
    item: PropTypes.shape({}).isRequired,
    saveData: PropTypes.func.isRequired
};

export default AdditionalInterestDetails;
